var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "dashboard px-6",
      attrs: { id: "tickets-dashboard", fluid: "", "fill-height": "" }
    },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "py-3", attrs: { cols: "12" } },
            [_c("TicketsDashboardHeader")],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "12" } },
            [_c("TicketsHeaderCards")],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6" } },
            [_c("TicketsByStatus")],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6" } },
            [_c("TicketsByType")],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "d-flex-- flex-column-",
              attrs: { cols: "12", sm: "8" }
            },
            [_c("TicketsTable")],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "d-flex- flex-column-",
              attrs: { cols: "12", sm: "4" }
            },
            [
              _c("TicketsMonthSummary", { staticClass: "mb-6" }),
              _c("TicketsLastNMonthsActivity", { staticClass: "mb-6" }),
              _c("TicketsReviewDot")
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { top: "", color: "error" },
          model: {
            value: _vm.loadingError,
            callback: function($$v) {
              _vm.loadingError = $$v
            },
            expression: "loadingError"
          }
        },
        [
          _vm._v(
            " Ocurrió un error obteniendo los datos asociados a tickets. Por favor cargue la página de nuevo "
          ),
          _c(
            "v-btn",
            {
              attrs: { color: "white", text: "" },
              on: {
                click: function($event) {
                  _vm.loadingError = false
                }
              }
            },
            [_vm._v("Cerrar")]
          )
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { top: "", timeout: _vm.timeout, color: "success" },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _vm._v(
            " Su ticket fue creado exitosamente (Serial Nº " +
              _vm._s(_vm.newTicketId) +
              ") "
          ),
          _c(
            "v-btn",
            {
              attrs: { color: "white", text: "" },
              on: {
                click: function($event) {
                  _vm.snackbar = false
                }
              }
            },
            [_vm._v("Cerrar")]
          )
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { top: "", timeout: _vm.timeout, color: "error" },
          model: {
            value: _vm.snackbarError,
            callback: function($$v) {
              _vm.snackbarError = $$v
            },
            expression: "snackbarError"
          }
        },
        [
          _vm._v(
            " Ocurrió un error en la creación del ticket, por favor intente de nuevo "
          ),
          _c(
            "v-btn",
            {
              attrs: { color: "white", text: "" },
              on: {
                click: function($event) {
                  _vm.snackbarError = false
                }
              }
            },
            [_vm._v("Cerrar")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }